import {Box, Group} from "@mantine/core";
import {IconSum} from "@tabler/icons-react";
import {FormattedCurrency, FormattedCurrencyProps} from "../../../../text/FormattedCurrency/FormattedCurrency";

export type DataTableCostSumFooterProps = FormattedCurrencyProps & {}

export const DataTableCostCostSumFooter = (props: DataTableCostSumFooterProps) => {
  const {...rest} = props

  return (
    <Group spacing="xs">
      <Box mb={-4}>
        <IconSum size={16}/>
      </Box>
      <div>
        <FormattedCurrency {...rest} />
      </div>
    </Group>
  )
}
